import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { alertreturn, lastjoin, useridchecks } from '../service/project'
import Swal from 'sweetalert2'
import MetaTag from '../MetaTag'
import { metaSignin } from '../service/mataTags'
import { Input, Button, Select } from 'antd'
import GradeOverlayFull from '../../src/components/gradedoc'

import {
    UserOutlined,
    PhoneOutlined,
    BankOutlined,
    EnvironmentOutlined,
    MailOutlined,
    LockOutlined,
    ShopOutlined,
} from '@ant-design/icons'

function Signin() {
    const [addUser, setAddUser] = useState({
        uName: '', // 이름
        uPhone: '', // 연락처
        company: '', // 회사명 (수요/파트너)
        companyaddressf: '', // 회사주소 (기본, 수요/파트너)
        companyaddressm: '', // 회사주소 (상세, 수요/파트너)
        userId: '',
        email: '',
        uPassword: '',
        uNewPassword: '',
        ugrade: 0, // 0=수요 기업, 2=파트너, 3=시니어
        sector1: '', // 파트너 업종
        // 시니어 신규 필드
        seniorAddress: '', // 주소
        seniorAge: '', // 나이
        seniorGender: '', // 성별
        seniorMajor: '', // 전공
        seniorCareer: '', // 경력
        seniorDegree: '', // 최종학위
    })

    const [pass, setPass] = useState(false)
    const [truepass, setTruepass] = useState(false)
    const navigate = useNavigate()

    // 가입 타입
    const [isUserSignup, setIsUserSignup] = useState(true)
    const [isPartnerSignup, setIsPartnerSignup] = useState(false)
    const [isSeniorSignup, setIsSeniorSignup] = useState(false)

    const currentSignupLabel = isPartnerSignup ? '파트너' : isSeniorSignup ? '시니어' : '수요 기업'

    const location = useLocation()
    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const type = params.get('type')

        if (type === 'partner') {
            setIsUserSignup(false)
            setIsPartnerSignup(true)
            setIsSeniorSignup(false)
            setAddUser((prev) => ({ ...prev, ugrade: 2 }))
        } else if (type === 'senior') {
            setIsUserSignup(false)
            setIsPartnerSignup(false)
            setIsSeniorSignup(true)
            setAddUser((prev) => ({ ...prev, ugrade: 3 }))
        } else {
            setIsUserSignup(true)
            setIsPartnerSignup(false)
            setIsSeniorSignup(false)
            setAddUser((prev) => ({ ...prev, ugrade: 0 }))
        }
    }, [location.search])

    const { Option } = Select

    const industryOptions = [
        '제조업',
        '도·소매업',
        '정보통신업',
        '건설업',
        '금융 및 보험업',
        '전문·과학 및 기술 서비스업',
        '숙박 및 음식점업',
        '운수 및 창고업',
        '보건업 및 사회복지 서비스업',
        '교육 서비스업',
        '예술·스포츠 및 여가관련 서비스업',
        '기타',
    ]

    const degreeOptions = ['중졸', '고졸', '학사', '석사', '박사', '기타']
    const genderOptions = ['남', '여']

    const handleChange = (id, value) => {
        setAddUser((prevState) => ({
            ...prevState,
            [id]: value,
        }))
    }

    const useridCheck = (e) => {
        e.preventDefault()
        useridchecks(addUser.userId)
            .then(function (response) {
                if (response.data === true) {
                    Swal.fire('이미 등록된 아이디 입니다.', '확인 버튼을 눌러 주세요', 'warning')
                } else {
                    Swal.fire('사용가능한 아이디 입니다.', '확인 버튼을 눌러 주세요', 'success')
                }
            })
            .catch(function () {})
    }

    const registration = async (e) => {
        e.preventDefault()
        if (!addUser.email) {
            alertreturn('loses', '이메일을')
        } else if (!addUser.userId) {
            alertreturn('loses', '아이디를')
        } else if (!addUser.uPassword) {
            alertreturn('loses', '비밀번호를')
        } else if (!addUser.uNewPassword) {
            alertreturn('loses', '비밀번호확인을')
        } else if (!truepass) {
            alertreturn('checkno')
        } else {
            lastjoin(
                addUser.uPassword,
                addUser.email,
                addUser.userId,
                addUser.uName,
                addUser.uPhone,
                addUser.company,
                addUser.companyaddressf,
                addUser.companyaddressm,
                addUser.ugrade,
                addUser.sector1,
                addUser.seniorMajor,
                addUser.seniorCareer,
                addUser.seniorDegree,
                addUser.seniorAddress,
                addUser.seniorAge,
                addUser.seniorGender,
            )
                .then(function (response) {
                    if (response.data) {
                        Swal.fire('가입되었습니다', '확인 버튼을 눌러 주세요', 'success')
                        navigate('/')
                    }
                })
                .catch(function () {})
        }
    }

    let regPass = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{6,25}$/
    const regEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

    // 우측 요약 시트 (필요 시 사용)
    const sheetBox = {
        width: '100%',
        height: '100%',
        padding: '28px 24px',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        background: 'linear-gradient(180deg, #F8FAFC 0%, #FFFFFF 60%)',
    }
    const sheetTitle = {
        fontSize: 22,
        fontWeight: 900,
        marginBottom: 8,
        color: '#0f172a',
    }
    const InfoRow = ({ label, value }) => (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: 12,
                padding: '6px 0',
                borderBottom: '1px dashed #e5e7eb',
            }}
        >
            <div style={{ color: '#64748b', fontWeight: 600 }}>{label}</div>
            <div style={{ fontWeight: 700 }}>{value || '-'}</div>
        </div>
    )

    const RightSheet = () => (
        <div style={sheetBox}>
            <div style={sheetTitle}>{currentSignupLabel} 정보 요약</div>
            {isSeniorSignup ? (
                <>
                    <InfoRow label="이름" value={addUser.uName} />
                    <InfoRow label="연락처" value={addUser.uPhone} />
                    <InfoRow label="이메일" value={addUser.email} />
                    <InfoRow label="주소" value={addUser.seniorAddress} />
                    <InfoRow label="나이" value={addUser.seniorAge} />
                    <InfoRow label="성별" value={addUser.seniorGender} />
                    <InfoRow label="전공" value={addUser.seniorMajor} />
                    <InfoRow label="경력" value={addUser.seniorCareer} />
                    <InfoRow label="최종학위" value={addUser.seniorDegree} />
                </>
            ) : isPartnerSignup ? (
                <>
                    <InfoRow label="회사명" value={addUser.company} />
                    <InfoRow label="업종" value={addUser.sector1} />
                    <InfoRow label="주소" value={addUser.companyaddressf} />
                    <InfoRow label="담당자" value={addUser.uName} />
                    <InfoRow label="연락처" value={addUser.uPhone} />
                    <InfoRow label="이메일" value={addUser.email} />
                </>
            ) : (
                <>
                    <InfoRow label="회사명" value={addUser.company} />
                    <InfoRow label="주소" value={addUser.companyaddressf} />
                    <InfoRow label="담당자" value={addUser.uName} />
                    <InfoRow label="연락처" value={addUser.uPhone} />
                    <InfoRow label="이메일" value={addUser.email} />
                </>
            )}
        </div>
    )

    return (
        <section className="login">
            {/* 기본 Select placeholder 정렬 — 시니어가 아닐 때 기존 규칙 유지 */}
            {!isSeniorSignup && (
                <style>
                    {`
            .login .ant-select-selector {
              height: 55px !important;
              display: flex;
              align-items: center;
            }
            .login .ant-select-selection-placeholder {
              display: flex !important;
              align-items: center !important;
            }
          `}
                </style>
            )}

            {/* 시니어 모드: 모든 컨트롤 높이/라인하이트/폰트 통일 */}
            {isSeniorSignup && (
                <style>
                    {`
      /* === 높이 통일 === */
      .login .senior-uniform .ant-input,
      .login .senior-uniform .ant-input-number, 
      .login .senior-uniform .ant-input-affix-wrapper,
      .login .senior-uniform .ant-select-selector,
      .login .senior-uniform .ant-btn {
        height: 44px !important;
        min-height: 44px !important;
        font-size: 16px !important;
      }

      /* === Input 텍스트/placeholder 세로 가운데 === */
      .login .senior-uniform input.ant-input {
        height: 44px !important;
        line-height: 44px !important;         /* ← 가운데 정렬 핵심 */
        font-size: 16px !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }

      /* === Password(affix) 내부도 정확히 가운데 === */
      .login .senior-uniform .ant-input-affix-wrapper {
        display: flex;
        align-items: center;                   /* ← 아이콘/텍스트 모두 가운데 */
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }
      .login .senior-uniform .ant-input-affix-wrapper > input.ant-input {
        height: 44px !important;
        line-height: 44px !important;         /* ← 가운데 정렬 핵심 */
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }

      /* === Select 표시 영역/플레이스홀더 가운데 === */
      .login .senior-uniform .ant-select-selector {
        display: flex !important;
        align-items: center !important;        /* ← 가운데 정렬 핵심 */
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }
      .login .senior-uniform .ant-select-selection-item,
      .login .senior-uniform .ant-select-selection-placeholder {
        display: flex !important;
        align-items: center !important;        /* ← 가운데 정렬 핵심 */
        line-height: 44px !important;
        font-size: 16px !important;
      }

      /* === 버튼 텍스트도 완전 가운데 === */
      .login .senior-uniform .ant-btn {
        display: flex;
        align-items: center;
        justify-content: center;               /* ← 가로/세로 모두 가운데 */
        line-height: 1 !important;             /* 버튼은 flex로 중앙 정렬 */
        padding: 0 14px !important;
        font-weight: 600;
      }

      /* === 상단 타입 스위처: 텍스트 클릭 막기(체크박스만 클릭) === */
      .login .type-switch .text {
        pointer-events: none;
        cursor: default;
      }
      .login .type-switch input[type="checkbox"] {
        cursor: pointer;
      }
    `}
                </style>
            )}

            <MetaTag {...metaSignin} />
            <div
                className="login_box"
                style={{
                    display: 'flex',
                    width: '90vw',
                    maxWidth: '1300px',
                    height: '88vh',
                    borderRadius: '10px',
                    boxShadow: '1px 4px 22px -8px #0004',
                    overflow: 'hidden',
                    position: 'absolute',
                    top: '55%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    background: '#fff',
                    padding: '20',
                }}
            >
                {/* ===== 좌측 폼 ===== */}
                <div className={`left ${isSeniorSignup ? 'senior-uniform' : ''}`} style={{ flex: 1, minWidth: 0 }}>
                    <div className="top_link" style={{ marginBottom: '-40px' }}></div>
                    <div className="contact" style={{ marginTop: '25px' }}>
                        <form onSubmit={registration} style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                            {/* 가입 타입 3개 (체크박스만 클릭되게) */}
                            {/* 가입 타입 3개 (체크박스: 텍스트/라인 클릭 가능, 체크박스 자체는 포인터 제거) */}
                            <div
                                className="type-switch"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: '24px',
                                    marginTop: '-20px',
                                }}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1 }}>
                                    {/* <span style={{ color: '#1E3C72', fontSize: '30px', fontWeight: 'bold' }}>
                    {currentSignupLabel}
                  </span> */}
                                    <span style={{ fontSize: '30px', fontWeight: 'bold', marginTop: '4px' }}>
                                        회원가입
                                    </span>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '0px' }}>
                                    {/* 수요 기업 */}
                                    <label
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '-20px',
                                            cursor: 'pointer',
                                            userSelect: 'none',
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={isUserSignup}
                                            onChange={() => {
                                                setIsUserSignup(true)
                                                setIsPartnerSignup(false)
                                                setIsSeniorSignup(false)
                                                handleChange('ugrade', 0)
                                            }}
                                            style={{
                                                width: 22,
                                                height: 22,
                                                marginRight: 6,
                                                cursor: 'pointer',
                                            }}
                                        />
                                        <span style={{ fontSize: 18, fontWeight: 'bold' }}>수요 기업</span>
                                    </label>

                                    {/* 파트너 등록 */}
                                    <label
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '-20px',
                                            cursor: 'pointer',
                                            userSelect: 'none',
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={isPartnerSignup}
                                            onChange={() => {
                                                setIsUserSignup(false)
                                                setIsPartnerSignup(true)
                                                setIsSeniorSignup(false)
                                                handleChange('ugrade', 2)
                                            }}
                                            style={{
                                                width: 22,
                                                height: 22,
                                                marginRight: 6,
                                                cursor: 'pointer',
                                            }}
                                        />
                                        <span style={{ fontSize: 18, fontWeight: 'bold' }}>공급 기업</span>
                                    </label>

                                    {/* 시니어 등록 */}
                                    <label
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            userSelect: 'none',
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={isSeniorSignup}
                                            onChange={() => {
                                                setIsUserSignup(false)
                                                setIsPartnerSignup(false)
                                                setIsSeniorSignup(true)
                                                handleChange('ugrade', 3)
                                            }}
                                            style={{
                                                width: 22,
                                                height: 22,
                                                marginRight: 6,
                                                cursor: 'pointer',
                                            }}
                                        />
                                        <span style={{ fontSize: 18, fontWeight: 'bold' }}>시니어 등록</span>
                                    </label>
                                </div>
                            </div>

                            {/* 아이디 + 중복확인 */}
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Input
                                    prefix={<UserOutlined />}
                                    placeholder="아이디"
                                    value={addUser.userId}
                                    onChange={(e) => handleChange('userId', e.target.value)}
                                    style={{
                                        flex: 1,
                                        height: '55px',
                                        fontSize: '18px',
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        padding: '0px 10px',
                                    }}
                                />
                                <Button
                                    type="primary"
                                    onClick={useridCheck}
                                    style={{ marginLeft: 8, height: 55, lineHeight: '55px', width: 100, fontSize: 18 }}
                                >
                                    중복확인
                                </Button>
                            </div>

                            {/* 비밀번호 */}
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Input.Password
                                    prefix={<LockOutlined />}
                                    placeholder="비밀번호"
                                    value={addUser.uPassword}
                                    onChange={(e) => {
                                        setPass(true)
                                        handleChange('uPassword', e.target.value)
                                    }}
                                    style={{
                                        flex: 1,
                                        height: '55px',
                                        fontSize: '18px',
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                    }}
                                />
                            </div>
                            {pass && (
                                <p className={!regPass.test(addUser.uPassword) ? 'passerror' : 'pass_success'}>
                                    영문/숫자/특수문자 조합(6~20자)
                                    {regPass.test(addUser.uPassword) && ' ○'}
                                </p>
                            )}

                            {/* 비밀번호 확인 */}
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Input.Password
                                    prefix={<LockOutlined />}
                                    placeholder="비밀번호 확인"
                                    value={addUser.uNewPassword}
                                    onChange={(e) => handleChange('uNewPassword', e.target.value)}
                                    style={{
                                        flex: 1,
                                        height: '55px',
                                        fontSize: '18px',
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                    }}
                                />
                            </div>
                            {addUser.uPassword === addUser.uNewPassword && addUser.uNewPassword.length >= 6 ? (
                                <p className="pass_success">비밀번호가 일치합니다</p>
                            ) : addUser.uNewPassword.length >= 2 ? (
                                <p className="passerror">비밀번호가 일치하지 않습니다</p>
                            ) : null}

                            {/* 이름 */}
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Input
                                    prefix={<UserOutlined />}
                                    placeholder="이름"
                                    value={addUser.uName}
                                    onChange={(e) => handleChange('uName', e.target.value)}
                                    style={{
                                        flex: 1,
                                        height: '55px',
                                        fontSize: '18px',
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                    }}
                                />
                            </div>

                            {/* 연락처 */}
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Input
                                    prefix={<PhoneOutlined />}
                                    placeholder="연락처"
                                    value={addUser.uPhone}
                                    onChange={(e) => handleChange('uPhone', e.target.value)}
                                    style={{
                                        flex: 1,
                                        height: '55px',
                                        fontSize: '18px',
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                    }}
                                />
                            </div>

                            {/* 이메일 */}
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Input
                                    prefix={<MailOutlined />}
                                    placeholder="이메일"
                                    value={addUser.email}
                                    onChange={(e) => handleChange('email', e.target.value)}
                                    style={{
                                        flex: 1,
                                        height: '55px',
                                        fontSize: '18px',
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                    }}
                                />
                            </div>
                            {addUser.email && !regEmail.test(addUser.email) && (
                                <p className="passerror">이메일을 입력해주세요</p>
                            )}

                            {/* 회사 정보: 시니어는 숨김 */}
                            {!isSeniorSignup && (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Input
                                            prefix={<BankOutlined />}
                                            placeholder="회사명"
                                            value={addUser.company}
                                            onChange={(e) => handleChange('company', e.target.value)}
                                            style={{
                                                flex: 1,
                                                height: '55px',
                                                fontSize: '18px',
                                                paddingTop: 0,
                                                paddingBottom: 0,
                                            }}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Input
                                            prefix={<EnvironmentOutlined />}
                                            placeholder="회사주소"
                                            value={addUser.companyaddressf}
                                            onChange={(e) => handleChange('companyaddressf', e.target.value)}
                                            style={{
                                                flex: 1,
                                                height: '55px',
                                                fontSize: '18px',
                                                paddingTop: 0,
                                                paddingBottom: 0,
                                            }}
                                        />
                                    </div>
                                </>
                            )}

                            {/* 파트너: 업종 */}
                            {isPartnerSignup && (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Select
                                        placeholder={
                                            <span
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 8,
                                                    fontSize: 18,
                                                    fontWeight: 500,
                                                }}
                                            >
                                                <ShopOutlined style={{ color: 'black' }} />
                                                업종을 선택해주세요
                                            </span>
                                        }
                                        value={addUser.sector1 || undefined}
                                        onChange={(value) => handleChange('sector1', value)}
                                        style={{
                                            flex: 1,
                                            height: '55px',
                                            fontSize: '18px',
                                            paddingTop: 0,
                                            paddingBottom: 0,
                                        }}
                                        size="large"
                                    >
                                        {industryOptions.map((i) => (
                                            <Option key={i} value={i}>
                                                {i}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                            )}

                            {/* ====================== 시니어 추가 필드 ====================== */}
                            {isSeniorSignup && (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Input
                                            prefix={<EnvironmentOutlined />}
                                            placeholder="주소를 입력해주세요"
                                            value={addUser.seniorAddress}
                                            onChange={(e) => handleChange('seniorAddress', e.target.value)}
                                            style={{ flex: 1 }}
                                        />
                                    </div>

                                    <div style={{ display: 'flex', gap: 10 }}>
                                        <Input
                                            type="text"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            prefix={<UserOutlined />}
                                            placeholder="나이"
                                            value={addUser.seniorAge}
                                            onChange={(e) =>
                                                handleChange('seniorAge', e.target.value.replace(/\D/g, ''))
                                            }
                                            style={{ flex: 1 }}
                                        />

                                        <Select
                                            placeholder="성별"
                                            value={addUser.seniorGender || undefined}
                                            onChange={(v) => handleChange('seniorGender', v)}
                                            style={{ flex: 1 }}
                                            options={genderOptions.map((g) => ({ label: g, value: g }))}
                                        />
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Input
                                            prefix={<UserOutlined />}
                                            placeholder="전공을 입력해주세요"
                                            value={addUser.seniorMajor}
                                            onChange={(e) => handleChange('seniorMajor', e.target.value)}
                                            style={{ flex: 1 }}
                                        />
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Input
                                            prefix={<UserOutlined />}
                                            placeholder="경력 (예: PCB 20년 / 로봇 SI 15년 등)"
                                            value={addUser.seniorCareer}
                                            onChange={(e) => handleChange('seniorCareer', e.target.value)}
                                            style={{ flex: 1 }}
                                        />
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Select
                                            placeholder={
                                                <span
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 8,
                                                        fontSize: 16,
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    <BankOutlined style={{ color: 'black' }} />
                                                    최종 학위를 선택해주세요
                                                </span>
                                            }
                                            value={addUser.seniorDegree || undefined}
                                            onChange={(value) => handleChange('seniorDegree', value)}
                                            style={{ flex: 1 }}
                                            size="middle"
                                        >
                                            {degreeOptions.map((d) => (
                                                <Option key={d} value={d === '선택 없음' ? '' : d}>
                                                    {d}
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                </>
                            )}
                            {/* ====================== /시니어 추가 필드 ====================== */}

                            {/* 동의 */}
                            <label
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    marginTop: 5,
                                    fontSize: 18,
                                    fontWeight: 'bold',
                                }}
                            >
                                <input onChange={() => setTruepass(!truepass)} className="check mr10" type="checkbox" />
                                회원 가입에 동의 하시겠습니까?
                            </label>

                            <button
                                className="submit"
                                type="submit"
                                style={{
                                    position: 'static',
                                    marginTop: 5,
                                    width: '100%',
                                    fontSize: 20,
                                }}
                            >
                                회원가입 완료
                            </button>
                        </form>
                    </div>
                </div>

                {/* ===== 우측: 이미지 + 타입별 설명 ===== */}
                <div className="right" style={{ flexBasis: '60%', position: 'relative' }}>
                    <img
                        src={require('../../src/Image/login.jpg')}
                        alt="외주개발 니즈로봇 가입 페이지"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            display: 'block',
                            filter: 'brightness(0.45)',
                        }}
                    />
                    <GradeOverlayFull />
                </div>
            </div>
        </section>
    )
}

export default Signin
